var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-flatpickr-component',{staticClass:"vuestic-date-picker",attrs:{"value":_vm.pickerValue,"config":_vm.pickerConfig},on:{"input":_vm.onValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }